
class addTemplateSetUpCtrl {
    constructor($scope, $state, logger, httpRequest, $uibModal, $timeout) {
        // console.log($state.params);
        $scope.hasModal = {
            flag: false,
        }
        $scope.resObj = {
            qrCodeList: [],
            isSaveContract: '1',
            isSaveInvoice: '1',
            qrcodeChoice: '1',
            barcodeChoice: '1',
            markList: [{
                coverMarkName: '',
                remark: '',
                editState: 0,
                qryPageName: '单据编号',
                isUserDefine: 1,
            }, {
                coverMarkName: '',
                remark: '',
                editState: 0,
                qryPageName: '单据金额',
                isUserDefine: 1,
            }],
        }
        if ($state.params.templateId) {
            httpRequest.post_getContractTemplateList({
                pageNum: 1,
                pageSize: 10,
                param: {
                    templateId: $state.params.templateId,
                },
            }).then((res) => {
                $timeout(() => {
                    $scope.resObj = res.data.value.list[0]
                })
            })
        }
        // 字典值
        httpRequest.get_dictByTypeArr(['biz_type']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.isEdit = false
        $scope.delConfig = {
            title: '删除',
            msg: '确定要删除本条信息吗？',
            btnName: ['取消', '确定'],
        }
        $scope.saveConfig1 = {
            title: '保存',
            arr: [{
                msg: '有相同的二维码名称， 请重新输入！',
                btnName: ['好的'],
                flag: false,
                hasCallback: false,
            }, {
                msg: '未填写二维码名称， 确定放弃添加？',
                btnName: ['取消', '确定'],
                flag: false,
                hasCallback: true,
            }],
        }
        $scope.saveConfig = {
            title: '保存',
            arr: [{
                msg: '有相同的封面标识名称或页面查询名称， 请重新输入！',
                btnName: ['好的'],
                flag: false,
                hasCallback: false,
            }, {
                msg: '未填写封面标识名称， 确定放弃添加？',
                btnName: ['取消', '确定'],
                flag: false,
                hasCallback: true,
            }],
        }
        $scope.inputFocus = function inputFocus(obj) {
            obj.errorInput = false
        }
        $scope.add = function add(list) {
            if ($scope.isEdit || $scope.hasModal.flag) return
            if (list == null) {
                $scope.resObj.qrCodeList = []
                $scope.resObj.qrCodeList.push({
                    name: '',
                    remark: '',
                    editState: 1,
                })
            }
            if (list == $scope.resObj.qrCodeList) {
                list.push({
                    name: '',
                    remark: '',
                    editState: 1,
                })
            } else if (list == $scope.resObj.markList) {
                if (list.length > 4) {
                    logger.logError('自定义标识最多五个')
                    return
                }
                list.push({
                    coverMarkName: '',
                    remark: '',
                    editState: 1,
                    qryPageName: '',
                    isUserDefine: 0,
                })
            }

            $scope.isEdit = true
        }
        $scope.save = function save(obj, list, config, index) {
            let flagCount = 0
            if (obj.coverMarkName == '' || obj.name == '') {
                obj.errorInput = true
                config.arr[1].flag = true
                $scope.hasModal.flag = true
                return
            }
            list.forEach((element) => {
                if (element.coverMarkName && element.coverMarkName == obj.coverMarkName) {
                    flagCount++
                }
                if (index != 0 && index != 1 && (obj.coverMarkName == '单据编号' || obj.coverMarkName == '单据金额')) {
                    flagCount++
                }
                if (element.name && element.name == obj.name) {
                    flagCount++
                }
            })
            if (flagCount > 1) {
                obj.errorInput = true
                config.arr[0].flag = true
                $scope.hasModal.flag = true
                return
            }
            if ('qryPageName' in obj && index != 0 && index != 1) {
                obj.qryPageName = obj.coverMarkName
            }
            obj.editState = 0
            $scope.isEdit = false
        }
        $scope.del = function del(index, list) {
            list.splice(index, 1)
            $scope.isEdit = false
        }
        // 特殊情况关闭编辑窗
        $scope.closeEdit = function closeEdit(item) {
            item.editState = 0
            $scope.isEdit = false
        }
        $scope.edit = function edit(obj) {
            if ($scope.isEdit || $scope.hasModal.flag) return
            obj.editState = 1
            $scope.isEdit = true
        }
        $scope.checkLength = function checkLength(obj) {
            if ($scope.resObj.bizName && $scope.resObj.bizName.length > 15) {
                logger.logError('业务名称最多15个字符')
                $scope.resObj.bizName = $scope.resObj.bizName.substr(0, 15)
            }
            if (obj && obj.coverMarkName && obj.coverMarkName.length > 20) {
                logger.logError('封面标识名称最多20个字符')
                obj.coverMarkName = obj.coverMarkName.substr(0, 20)
            }
            if (obj && obj.name && obj.name.length > 20) {
                logger.logError('二维码名称最多20个字符')
                obj.name = obj.name.substr(0, 20)
            }
            if (obj && obj.remark && obj.remark.length > 100) {
                logger.logError('备注最多100个字符')
                obj.remark = obj.remark.substr(0, 100)
            }
        }
        $scope.rowUp = function rowUp(obj, index) {
            $scope.resObj.qrCodeList.splice(index, 1)
            $scope.resObj.qrCodeList.splice(index - 1, 0, obj)
        }
        $scope.rowDown = function rowDown(obj, index) {
            $scope.resObj.qrCodeList.splice(index, 1)
            $scope.resObj.qrCodeList.splice(index + 1, 0, obj)
        }
        $scope.preview = function preview() {
            $uibModal.open({
                template: require('./view/previewTemplateSetUp.html'),
                openedClass: 'mod-modal mod-modal-preview',
                controller: 'previewTemplateCtrl',
                animation: true,
                resolve: {
                    obj() {
                        return {
                            resObj: $scope.resObj,
                            state: 'add/edit',
                        }
                    },
                },
            })
        }
        $scope.cancel = function cancel() {
            $state.go('system.settingcenter.templateSetUp.list')
        }
        $scope.ok = function ok() {
            if (!$scope.resObj.qrcodeChoice && !$scope.resObj.barcodeChoice) {
                logger.logError('未选择二维码或者条形码，请选择')
                return
            }
            if (!$scope.resObj.markList[0].coverMarkName || !$scope.resObj.markList[1].coverMarkName) {
                logger.logError('未填写封面标识名称，请重新输入')
                return
            }
            $scope.resObj.markList.forEach((o, i) => {
                if (i != 0 && i != 1) o.qryPageName = o.coverMarkName
            })
            if ($state.params.templateId) {
                httpRequest.post_updateContractTemplate($scope.resObj).then((res) => {
                    if (res.data.value) $scope.cancel()
                    logger.logSuccess('编辑模版成功')
                })
            } else {
                httpRequest.post_addContractTemplate($scope.resObj).then((res) => {
                    if (res.data.success) $scope.cancel()
                    logger.logSuccess('新增模版成功')
                })
            }
        }
    }
}

addTemplateSetUpCtrl.$inject = ['$scope', '$state', 'logger', 'httpRequest', '$uibModal', '$timeout']
export default addTemplateSetUpCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetUp/addTemplateSetUpCtrl.js